var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardWidgetGauge',{staticClass:"widget-indice-indipendenza-terzi",attrs:{"loading":_vm.loading,"title":"Indice di Indipendenza da terzi","min":_vm.min,"max":_vm.max,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }